import type { SVGProps } from 'react';

export interface BrandMarkProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

/** Canonical Los Recomendados brand mark. Keep this geometry stable across public surfaces. */
export function BrandMark({ size = 32, width, height, ...props }: BrandMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1254 1254"
      width={width ?? size}
      height={height ?? size}
      fill="none"
      aria-hidden={props['aria-label'] ? undefined : true}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M568 53 468 74 410 96 361 121 277 181 245 211 201 263 149 349 113 448 97 560 104 675 131 778 179 878 241 962 323 1036 421 1094 526 1130 622 1144 683 1144 739 1138 821 1118 872 1092 887 1073 894 1052 892 1025 879 1001 859 989 836 988 759 1013 679 1024 609 1022 526 1005 444 971 389 935 335 884 289 820 262 767 245 719 232 663 226 603 228 541 239 475 258 416 289 355 320 312 368 264 414 231 460 207 515 188 568 177 608 173 688 176 751 189 804 208 888 258 934 301 963 338 991 386 1013 443 1026 500 1030 578 1023 639 1008 695 987 743 955 790 925 817 903 826 884 826 856 813 820 777 781 721 752 662 793 637 827 605 846 577 862 538 868 503 864 448 850 408 825 370 771 325 727 305 673 292 617 287 540 289 485 297 456 309 441 334 441 872 447 887 464 898 544 899 559 894 568 885 572 871 572 682 584 670 601 669 617 676 632 692 685 802 721 861 746 890 778 915 830 937 891 944 945 936 995 914 1030 887 1070 841 1098 796 1124 739 1144 673 1153 622 1156 536 1151 480 1125 381 1082 294 1015 209 943 148 856 98 769 67 672 51Z M572 397 650 398 678 406 705 422 727 448 736 477 735 506 719 538 699 554 671 564 573 566Z"
      />
    </svg>
  );
}
